module.exports = __webpack_public_path__ + "img/icon_08.270c1a62.png";